"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentTypeControl = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ramda = require("ramda");
var _Radio = require("../../../../../../../ui/Radio");
var _selectors = require("../../../../store/selectors");
var _PaymentRadio = require("./components/PaymentRadio");
var _LabelControl = _interopRequireDefault(require("../LabelControl"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var PaymentTypeControl = exports.PaymentTypeControl = function PaymentTypeControl(_ref) {
  var id = _ref.id,
    error = _ref.error,
    value = _ref.value,
    _onChange = _ref.onChange;
  var _useSelector = (0, _reactRedux.useSelector)(_selectors.getBookingOperator),
    _useSelector$paymentT = _useSelector.paymentTypes,
    paymentTypes = _useSelector$paymentT === void 0 ? [] : _useSelector$paymentT;
  var _useTranslation = (0, _reactI18next.useTranslation)('BOOKING_FORM_BY_OPERATOR'),
    t = _useTranslation.t;
  return !(0, _ramda.isEmpty)(paymentTypes) && /*#__PURE__*/_react.default.createElement(_LabelControl.default, {
    id: id,
    label: t('PAYMENT_TYPE_CONTROL_LABEL')
  }, /*#__PURE__*/_react.default.createElement(_Radio.Radio.Group, {
    error: error
  }, (0, _ramda.map)(function (_ref2) {
    var itemValue = _ref2.value,
      content = _ref2.content,
      description = _ref2.description,
      icon = _ref2.icon;
    return /*#__PURE__*/_react.default.createElement(_PaymentRadio.PaymentRadio, {
      key: itemValue,
      icon: icon,
      title: content,
      description: description,
      checked: value === itemValue,
      value: itemValue,
      onChange: function onChange(newValue) {
        return _onChange(Number(newValue));
      }
    });
  }, paymentTypes)));
};
PaymentTypeControl.propTypes = {
  id: _propTypes.default.string.isRequired,
  error: _propTypes.default.string,
  value: _propTypes.default.number,
  onChange: _propTypes.default.func.isRequired
};